import React from "react";
import Switch from "react-switch";
import { FormattedMessage } from "react-intl";

const TransportadorasGridFilters = ({ showInactivos, filtersLoading, onChangeInactivos }) => (
  <div className="card mb-2">
    <div className="card-body">
      <div className="row align-items-center">
        <div className="col-auto" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '10px' }}>
            <FormattedMessage id="transportadorasGridFilters.render.filtros.ver_inactivos" defaultMessage="Ver Inactivos" />
          </span>
          <Switch
            onChange={onChangeInactivos}
            checked={showInactivos}
            disabled={filtersLoading}
            offColor="#FF4961"
            onColor="#28D094"
          />
        </div>
      </div>
    </div>
  </div>
);

export default TransportadorasGridFilters;
